import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const login = createAsyncThunk(
    'login/login',
    async (userInfo) => {
        const requestBody = JSON.stringify(userInfo);
        try {
            const response = fetch(`${process.env.REACT_APP_BASE_URL}/login`,
                {
                    method: 'POST',
                    headers: { 
                        "Content-Type": "application/json",
                        "Authorization": `Basic ${btoa(`${userInfo.username}:${userInfo.password}`)}`
                    },
                    body: requestBody
                }
            )
            .then(response => {
                if (response.ok) {
                    return response.text()
                } else {
                    throw new Error("Incorrect credentials");
                }
            });
            return response;
        } catch (error) {
            return error.message
        }
    }
)

export const loginSlice = createSlice({
    name: 'login',
    initialState: {
        loggedIn: false,
        loggingIn: false,
        failedLogin: false,
        errorMessage: "",
        formUserId: "",
        formPassword: "",
        token: ""
    },
    reducers: {
        logout: (state) => {
            return {
                ...state,
                loggedIn: false,
                formUserId: "",
                formPassword: "",
                token: ""
            }
        },
        changeFormUserId: (state, action) => {
            return {
                ...state,
                formUserId: action.payload
            }
        },
        changeFormPassword: (state, action) => {
            return {
                ...state,
                formPassword: action.payload
            }
        },
        changeDisplayName: (state, action) => {
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    displayName: action.payload
                }
            }
        },
        changePassword: (state, action) => {
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    password: action.payload
                }
            }
        },
        changeFailed: (state, action) => {
            return {
                ...state,
                failedLogin: action.payload
            }
        }
    },
    extraReducers: {
        [login.pending]: (state) => {
            return {
                ...state,
                loggingIn: true,
                failedLogin: false
            }
        },
        [login.fulfilled]: (state, action) => {
            return {
                ...state,
                loggedIn: true,
                loggingIn: false,
                token: action.payload
            }
        },
        [login.rejected]: (state, action) => {
            console.log(action);
            return {
                ...state,
                loggingIn: false,
                failedLogin: true,
                errorMessage: action.error.message
            }
        }
    }
})

export const isLoggedIn = (state) => state.login.loggedIn;
export const isLoggingIn = (state) => state.login.loggingIn;
export const failedLogin = (state) => state.login.failedLogin;
export const selectLoginError = (state) => state.login.errorMessage;
export const selectFormUserId = (state) => state.login.formUserId;
export const selectFormPassword = (state) => state.login.formPassword;
export const selectToken = (state) => state.login.token;

export const { changeFailed, logout, changeFormPassword, changeFormUserId, changeDisplayName, changePassword } = loginSlice.actions;

export default loginSlice.reducer;
